import { useEffect, useState } from 'react'

import { useNavigate } from 'react-router-dom';
// redux
import { useSelector } from 'react-redux';
import { RootState } from '../store';
// mui components
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
// componentes propios
import Sidebar from '../components/Sidebar/SidebarEdicion';
import Appbar from '../components/Appbar/Appbar';
import Cargando from '../components/Cargando/Cargando';

const drawerWidth = 240;

interface Props {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window?: () => Window;
    children: JSX.Element;
}

const Admin = (props: Props) => {

    const { window, children } = props;

    const navigate = useNavigate();

    const { curso } = useSelector((state: RootState) => state.curso);
    const { modulos, isLoading } = useSelector((state: RootState) => state.modulo);

    useEffect(() => {
        if(curso.cid === '') {
            navigate('/inicio');
        }
    }, [curso, navigate])

    const [mobileOpen, setMobileOpen] = useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const container = window !== undefined ? () => window().document.body : undefined;
    
    if (isLoading) {
        return <Cargando />
    }
        
    return (
        <Box sx={{ 
            display: 'flex', 
            // backgroundColor: '#f5f5f5' 
        }} >
            <CssBaseline />

                <Appbar 
                    handleDrawerToggle={handleDrawerToggle} 
                    titulo={curso.nombre}
                />

            <Box
                component="nav"
                sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
                aria-label="mailbox folders"
            >
                {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: { xs: 'block', sm: 'none' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                >
                    <Sidebar 
                        curso={curso} 
                        modulos={modulos}
                    />
                </Drawer>
                <Drawer
                    variant="permanent"
                    sx={{
                        display: { xs: 'none', sm: 'block' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                    open
                >
                    <Sidebar 
                        curso={curso} 
                        modulos={modulos}
                    />
                </Drawer>
            </Box>
            <Box
                component="main"
                sx={{ flexGrow: 1, px: {md: 5, sm: 3, xs: 1}, mt: 3, mb: 5, width: { sm: `calc(100% - ${drawerWidth}px)` }}}
            >
                <Toolbar />
                {children}
            </Box>
        </Box>
    )
}

export default Admin;